module.exports = __webpack_public_path__ + "img/a1.d70cfb2b.jpeg";